import { Record } from "immutable";
import { GLOBAL_CURRENT_DATETIME } from "core/datetime";
import omit from "lodash/omit";

const defaultModel = {
  id: 0,
  display_id: "",
  name: "",
  description: "",
  machine: null,
  component: null,
  assignee: null,
  assignee_detail: null,
  reporter: null,
  status: 0,
  priority: 0,
  __rawMachineStatuses: [],
  params: {},
  recommendation: "",
  project: null,
  project_name: "",
  estimated_saving: 0,
  diagnostic_severity: 0,
  inspection_severity: 0,
  machine_status: 0,
  open: false,
  open_date: GLOBAL_CURRENT_DATETIME,
  failure_mode: 0,
  failure_mode_name: null,
  create_user: null,
  create_date: null,
  attributes: {},
  labels: [],
  site_name: "",
  machine_name: ""
};
const CaseModelStateRecord = Record(defaultModel);

class CaseModelState {
  _immutable;

  static createEmpty() {
    return CaseModelState.create({ currentContent: {} });
  }

  static createWithContent(existingCaseData) {
    return CaseModelState.create({ currentContent: existingCaseData });
  }

  static create(config) {
    const { currentContent } = config;
    return new CaseModelState(new CaseModelStateRecord(currentContent));
  }

  static set(caseModelState, put) {
    const map = caseModelState.getImmutable().withMutations(state => {
      state.merge(put);
    });
    return new CaseModelState(map);
  }

  static setFromUpdatePayload(caseModelState, put) {
    const filteredPut = omit(put, ["alarms"]);
    return CaseModelState.set(caseModelState, filteredPut);
  }

  static clone(instance) {
    return CaseModelState.createWithContent(instance.toJS());
  }

  constructor(immutable) {
    this._immutable = immutable;
  }

  getImmutable() {
    return this._immutable;
  }

  getMutable() {
    return this.getImmutable().asMutable();
  }

  toJS() {
    return this.getImmutable().toJS();
  }

  toUpdatePayload() {
    const payload = this.toJS();
    return omit(payload, [
      "__rawMachineStatuses",
      "scalar_configurations",
      "assignee_detail"
    ]);
  }
}

export default CaseModelState;
